<template>
  <div class="login-box">
    <div class="login-p" v-if="loginState">登录</div>
    <div class="login-p" v-if="!loginState">注册</div>
    <router-link to="/" class="login-logo">
      <van-image width="3.21rem" height="0.6rem" :src="logo"></van-image>
    </router-link>
    <div class="login-form" v-if="loginState">
      <van-field v-model="loginForm.username" :left-icon="uIcon" clearable placeholder="请输入手机号码" />
      <van-field
        :left-icon="pIcon"
        label-width="3rem"
        v-model="loginForm.yzm"
        placeholder="请输入短信验证码"
      >
        <van-button
          slot="button"
          size="small"
          type="default"
          @click="getCode(loginForm.username)"
        >{{ saveYzm }}</van-button>
      </van-field>
    </div>
    <div class="login-form" v-if="!loginState">
      <van-field v-model="signForm.username" :left-icon="sIcon" clearable placeholder="请输入手机号码" />
      <van-field
        :left-icon="uIcon"
        label-width="3rem"
        v-model="signForm.phone"
        placeholder="请输入手机号码"
      />
      <van-field
        :left-icon="uIcon"
        label-width="3rem"
        v-model="signForm.yzm"
        placeholder="请输入短信验证码"
      >
        <van-button
          slot="button"
          size="small"
          type="default"
          @click="getCode(signForm.username)"
        >{{ saveYzm }}</van-button>
      </van-field>
    </div>
    <div class="login-btn" v-if="loginState" @click="login">
      <span>立即登录</span>
      <img src="../assets/images/login/arr.png" alt />
    </div>
    <div class="login-btn no-login" v-if="!loginState">
      <span>立即注册</span>
      <img src="../assets/images/login/arr.png" alt />
    </div>
    <div class="ligin-foot-p">
      <div class="left-p" v-if="!loginState">
        已有账号？
        <a href="javascript:;" @click="loginState = true">马上登陆</a>
      </div>
      <!-- <div class="right-p" v-if="loginState">
        还没有账号？
        <a href="javascript:;" @click="loginState = false">立即注册</a>
      </div> -->
    </div>
  </div>
</template>

<script>
import { Field, Image, Button } from "vant";
import logo from "@/assets/images/login/logo.png";
import uIcon from "@/assets/images/login/p.png";
import pIcon from "@/assets/images/login/pass.png";
import sIcon from "@/assets/images/login/u.png";
import Cookies from "js-cookie";
import { getToken, setToken, removeToken } from "@/utils/auth"; // get token from cookie
import { GetWechatAuthUrl } from "@/utils/common";
import { getAccessToken } from "@/api/wechat";
import { sendCode } from "@/api/common";
import { logIn } from "@/api/account/account";
import moment from "moment";

export default {
  name: "login",
  data() {
    return {
      msg: "登录注册",
      logo: logo,
      uIcon: uIcon,
      pIcon: pIcon,
      sIcon: sIcon,
      saveYzm: "发送验证码",
      loginState: true, // 是否登录状态
      loginForm: {
        username: "",
        yzm: ""
      },
      signForm: {
        username: "",
        phone: "",
        yzm: ""
      },
      codeTime: 0, // 发送验证码的时间
      timeOut: "", // 倒计时事件
      access_token: '', //网页授权接口调用凭证
    };
  },
  created() {
    // 获取openid
    //const openid = getOpenid();
    const openid = ''
    let { code, state } = this.$route.query;

    if(window.location.host.indexOf('192.168.') > -1) { //测试环境使用
      code = '021c5TBX0DslZV1qliEX0EA9CX0c5TBI'
    }

    if(!openid) {
      if(!code) {
        // 跳转到微信网页授权
        console.info('跳转到微信网页授权', GetWechatAuthUrl())
        window.location.href = GetWechatAuthUrl();
      }
      else {
        // 获取openid
        console.info("通过code获取openid", code);
        getAccessToken(code).then(response => {
          const { code, msg, data } = response;
          if (code >= 0) {
            console.info('getAccessToken -> data', data)
            setOpenid(data.openid, moment().add(365, 'days').format('YYYY-MM-DD'))
            this.access_token = data.access_token
          }
        })
        .catch(response => {
          this.tips(`${response.msg}。请刷新页面后再试`);
        });
      }
    }
    else {
      console.info('可以直接登录')
    }
    

    // if (!openid) {
    // //if (true) {
    //   let { code, state } = this.$route.query;
    //   const machineCode = Cookies.set(
    //     "lshoot-qupaipai-hkm-account-machineCode"
    //   );

    //   console.info(`code:${code}, state:${state}, machineCode:${machineCode}`);

    //   let isCheckOk = machineCode == state && code
    //   if(window.location.host.indexOf('192.168.') > -1) { //测试环境使用
    //     isCheckOk = true;
    //     code = '071rpgPt0lcP4j1EtkOt0GfkPt0rpgPQ'
    //   }

    //   if (isCheckOk) {
    //     // 获取openid
    //     getAccessToken(code).then(response => {
    //       const { code, msg, data } = response;
    //       if (code >= 0) {
    //         console.info('getAccessToken -> data', data)
    //         setOpenid(data.openid, moment().add(365, 'days').format('YYYY-MM-DD'))
    //         this.access_token = data.access_token
    //       }
    //     })
    //     .catch(response => {
    //       this.tips(`${response.msg}。请刷新页面后再试`);
    //     });
    //   } else {
    //     // 跳转到微信网页授权
    //     window.location.href = GetWechatAuthUrl();
    //   }
    // }
  },
  methods: {
    // yzm
    getCode: function(mobile) {
      let self = this;
      if (!self.regPhoneNumber(mobile)) {
        self.tips("请确保手机号码是正确的！");
        return;
      }
      if (self.codeTime !== 0) {
        self.tips("请勿重复点击发送验证码！");
        return;
      }

      sendCode(mobile).then(response => {
        const { code, msg, data } = response;
        if (code >= 0) {
          console.info('sendCode -> data', data)
        }
      })
      .catch(response => {
        this.tips(`${response.msg}`);
      });

      self.tips("验证码已发送，请注意查收");
      self.codeTime = 60;
      // 自调用
      self.timeOut = setInterval(() => {
        self.codeTime--;
        self.saveYzm = self.codeTime + "s";
        if (self.codeTime === 0) {
          clearInterval(self.timeOut);
          self.saveYzm = "发送验证码";
        }
      }, 1000);

      //   this.getAjax(
      //     "get",
      //     lshoot.api.sms.sendCode + "?mobile=" + mobile,
      //     {},
      //     function(res) {
      //       self.tips("验证码已发送，请注意查收");
      //       self.codeTime = 60;
      //       // 自调用
      //       self.timeOut = setInterval(() => {
      //         self.codeTime--;
      //         if (self.codeTime === 0) {
      //           clearInterval(self.timeOut);
      //         }
      //       }, 1000);
      //     }
      //   );
    },
    // 登录
    login() {
      console.info('login', this.loginForm)
      const {username, yzm} = this.loginForm
      if(username == '') {
        this.tips("请输入手机号码");
        return;
      }
      if(yzm == '') {
        this.tips("请输入短信验证码");
        return;
      }

      const parm = {
        //appid: Appid,
        access_token: this.access_token,
        mobile: username,
        code: yzm,
      }
      
      logIn(parm).then(response => {
        this.load(true, '加载中...');
        const { code, msg, data } = response;
        if (code >= 0) {
          // const openid = getOpenid();
          // setToken(openid, moment().add(365, 'days').format('YYYY-MM-DD'))
          // window.location.href = `/?role=${data.role}`
          debugger
          this.load(false);
        }
      })
      .catch(response => {
        this.load(false);
        this.tips(response.msg);
      });
    },
  },
  components: {
    "van-field": Field,
    "van-image": Image,
    "van-button": Button
  }
};
</script>

<style lang="less" scope>
@import "../assets/less/common.less";
@import "../assets/less/mixin.less";
.login-box {
  background: url(../assets/images/login/bg.png) top left no-repeat #000;
  background-size: 7.5rem auto;
  width: 100%;
  height: 100%;
  padding-left: 0.5rem;
  .login-p {
    height: 0.35rem;
    font-family: PingFang-SC-Bold;
    font-size: 0.38rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.4rem;
    letter-spacing: 0rem;
    color: #333333;
    padding-top: 0.67rem;
  }
  .login-logo {
    margin-top: 0.64rem;
    margin-bottom: 1.14rem;
    display: block;
  }
  .login-form {
    width: 5.8rem;
    margin-left: -0.3rem;
    .van-cell {
      background: transparent;
    }
  }
  .login-btn {
    font-family: PingFang-SC-Medium;
    font-size: 0.42rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.38rem;
    letter-spacing: 0rem;
    color: #ffffff;
    text-align: center;
    width: 6.07rem;
    height: 1.62rem;
    line-height: 1.3rem;
    background: url(../assets/images/login/btn.png) top center no-repeat;
    background-size: 6.07rem 1.62rem;
    opacity: 0.8;
    display: flex;
    margin-top: 2.48rem;
    &.no-login {
      margin-top: 1.6rem;
    }
    span {
      display: block;
      width: 3.5rem;
      text-align: right;
      margin-right: 0.3rem;
    }
    img {
      width: 0.61rem;
      height: 0.46rem;
      display: block;
      margin-top: 0.42rem;
    }
    &:act {
      opacity: 1;
    }
  }
  .ligin-foot-p {
    height: 0.28rem;
    font-family: PingFang-SC-Medium;
    font-size: 0.26rem;
    font-weight: normal;
    font-stretch: normal;
    line-height: 0.34rem;
    letter-spacing: 0rem;
    color: #ffffff;
    width: 100%;
    margin-top: 2.6rem;
    .left-p {
      width: 100%;
      text-align: left;
    }
    .right-p {
      width: 85%;
      text-align: right;
    }
    a {
      color: #fff;
      border-bottom: 1px solid #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login.vue